/**
 * @generated SignedSource<<a4dc4a7c36046595469fdd2a0a0b2108>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BasicInfoFormPartner_partner$data = {
  readonly about: string | null;
  readonly displayName: string;
  readonly id: string;
  readonly location: string | null;
  readonly slug: string;
  readonly thumbnailUrl: string;
  readonly user: {
    readonly phoneNumber: string | null;
  } | null;
  readonly " $fragmentType": "BasicInfoFormPartner_partner";
};
export type BasicInfoFormPartner_partner$key = {
  readonly " $data"?: BasicInfoFormPartner_partner$data;
  readonly " $fragmentSpreads": FragmentRefs<"BasicInfoFormPartner_partner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BasicInfoFormPartner_partner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "about",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PartnerNode",
  "abstractKey": null
};

(node as any).hash = "531ad3de1d5c5c17ab83e595b010ea57";

export default node;
